
import React from 'react';
import Navigation from '../../components/feature/Navigation';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import ServicesSection from './components/ServicesSection';
import TestimonialsSection from './components/TestimonialsSection';
import SpeakingSection from './components/SpeakingSection';
import ContactSection from './components/ContactSection';

const Home: React.FC = () => {
  return (
    <div className="min-h-screen">
      <Navigation />
      <main>
        <HeroSection />
        <AboutSection />
        <ServicesSection />
        <TestimonialsSection />
        <SpeakingSection />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
};

export default Home;
